import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-bookindent',
  templateUrl: './bookindent.component.html',
  styleUrls: ['./bookindent.component.scss'],
  providers:[LibraryService],
})
export class BookindentComponent implements OnInit {
  bookdetails:any[];
  booksmodel:any={};
  @ViewChild('dt') table: any;

  statuses = [
    {value: 'Approved', label: 'Approved'},
    {value: 'Hold', label: 'Hold'},
    {value: 'Pending', label: 'Pending'},
    {value: 'Cancel', label: 'Cancel'},
   
  
  ];
  defstat='All';
  arrstatus=[{value: 'All', label: 'All'},{value: 'Approved', label: 'Approved'},
  {value: 'Hold', label: 'Hold'},
  {value: 'Pending', label: 'Pending'},
  {value: 'Cancel', label: 'Cancel'}];
  oprtype:string;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    private smallmodalRef: NgbModalRef;
    roid=localStorage.getItem('role');
    constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {
  
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
      }
     }

  ngOnInit(): void {

    this.getbookdetails();
  }
  openbookdialog(content,formdata,cmd) {
    debugger
    console.log("formdata",formdata);
    this.modalOptions={size:'lg'};
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.booksmodel={};
   
     
      this.booksmodel.inid='0';
     
      
      //this.booksmodel.rstatus='Active';
    
      this.booksmodel.publisher='';
  
      
      
      this.booksmodel.author='';
      this.booksmodel.indt=new Date();

      this.booksmodel.rmks='';
      this.booksmodel.note='';
      this.booksmodel.qty='1';
      this.booksmodel.edition='';
     
      this.booksmodel.title='';
      this.booksmodel.subtitle='';
     
  
  
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
    }
    else if (cmd=='update')
    {
      
      this.booksmodel=formdata;
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
  
    }
    
    
      
    
  
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  exportindent(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
    let roid=localStorage.getItem('role');
    let memid=localStorage.getItem('usid');
     var url=this.liservice.callurl+"export/expbookindent.php?clcd="+clcd+"&aycd="+aycd+"&memid="+memid+"&roid="+roid+"&status="+this.defstat;
  
    // window.open(url,'','_blank');
    window.open(url);
   }

  getbookdetails() {
    this.liservice.getmemlibtindent(this.defstat)
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.bookdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}


  savebookdetails()
  {


    console.log('savedetails',this.booksmodel);
    this.liservice.savelibtindent(this.booksmodel,this.oprtype)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }

  openauthdialog(content,formdata,cmd) {
    debugger
    console.log("formdata",formdata);
    this.modalOptions={size:'sm'};
    this.oprtype=cmd;
   
      
      this.booksmodel=formdata;
      this.booksmodel.aqty=formdata.iqty;
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
  
    }
    
    
      
    
  
  

  
  saveauthdetails()
  {


    console.log('savedetails',this.booksmodel);
    this.liservice.authlibtindent(this.booksmodel)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }


}
